import { Card, ScrollSpy, ScrollSpyProps } from '@payaca/ambrosia';
import { FC, PropsWithChildren } from 'react';

export interface Props {
  sections: ScrollSpyProps['sections'];
  header: React.JSX.Element;
}

const EnaFormLayout: FC<PropsWithChildren<Props>> = (props) => {
  const { sections, header, children } = props;

  return (
    <div className="space-y-4">
      <ScrollSpy
        sections={sections}
        scrollElement={
          document.getElementById('main-page-content') || document.body
        }
        scrollOffset={200}
      >
        <Card className="z-sticky sticky -top-3 my-4">
          <Card.Body>
            <div className="mb-4 flex items-center gap-2">{header}</div>

            <ScrollSpy.Nav className="-mx-4 -mb-4 rounded-b-xl px-4 md:-mx-5 md:-mb-5 md:px-5" />
          </Card.Body>
        </Card>

        <ScrollSpy.Sections />

        {children}
      </ScrollSpy>
    </div>
  );
};

export default EnaFormLayout;
